import { useRef } from 'react';

export const useTour = () => {
  const uploadFilesRef = useRef(null);

  const steps = [
    {
      title: 'Страница приложений',
      description:
        'Добро пожаловать в раздел «Приложения» — централизованное хранилище актуальных версий тактических приложений для работы в едином контуре.',
      target: null,
    },
    {
      title: 'Страница приложений',
      description:
        'В разделе размещаются установочные файлы последних версий приложений «Гроза» и «Глаз». Устройства автоматически проверяют наличие обновлений и, при необходимости, загружают новую версию с сервера для быстрой установки. Это обеспечивает стабильную, актуальную и синхронизированную работу всего контура.',
      target: null,
    },
    {
      title: 'Обновление версий',
      description:
        'Загрузите актуальную версию приложения на сервер. После загрузки устройства смогут автоматически обновиться до новой версии.',
      target: () => uploadFilesRef.current,
    },
  ];

  return {
    uploadFilesRef,
    steps,
  };
};
